export default ({
  state: {
    plannerRoute: {},
    plannerResponse: undefined,
    plannerOrigin: undefined,
    plannerDestination: undefined,
    plannerOriginCoordinates: undefined,
    plannerDestinationCoordinates: undefined,
    plannerSelectedTransports: undefined,
    plannerTimeMode: undefined,
    plannerTimeModeHour: undefined,
    plannerTimeModeDate: undefined,
    plannerSelectedOperators: {},
    plannerSelectedTime: undefined,
  },
  mutations: {
    setPlannerRoute(state, route) {
      state.plannerRoute = route
    },
    setGooglePlannerResponse(state, response) {
      state.plannerResponse = response
    },
    setPlannerOrigin(state, origin) {
      state.plannerOrigin = origin
    },
    setPlannerDestination(state, destination) {
      state.plannerDestination = destination
    },
    setPlannerOriginCoordinates(state, originCoordinates) {
      state.plannerOriginCoordinates = originCoordinates
    },
    setPlannerDestinationCoordinates(state, destinationCoordinates) {
      state.plannerDestinationCoordinates = destinationCoordinates
    },
    setPlannerSelectedTransports(state, selectedTransports) {
      state.plannerSelectedTransports = selectedTransports
    },
    setPlannerTimeMode(state, mode) {
      state.plannerTimeMode = mode
    },
    setPlannerTimeModeHour(state, hour) {
      state.plannerTimeModeHour = hour
    },
    setPlannerTimeModeDate(state, date) {
      state.plannerTimeModeDate = date
    },
    resetPlannerState(state) {
      state.plannerOrigin = undefined
      state.plannerDestination = undefined
      state.plannerTimeMode = undefined
      state.plannerTimeModeHour = undefined
      state.plannerTimeModeDate = undefined
      state.plannerResponse = undefined
      state.plannerOriginCoordinates = undefined
      state.plannerDestinationCoordinates = undefined
      state.plannerSelectedTransports = undefined
      state.plannerSelectedTime = undefined 
    },
    setPlannerSelectedTime(state, time) {
      state.plannerSelectedTime = time
    },
    setPlannerSelectedOperators(state, operators) {
    state.plannerSelectedOperators = operators
  },
  },
  getters: {
    getPlannerRoute(state) {
      return state.plannerRoute
    },
    getPlannerResponse(state) {
      return state.plannerResponse
    },
    getPlannerOrigin(state) {
      return state.plannerOrigin
    },
    getPlannerDestination(state) {
      return state.plannerDestination
    },
    getPlannerOriginCoordinates(state) {
      return state.plannerOriginCoordinates
    },
    getPlannerDestinationCoordinates(state) {
      return state.plannerDestinationCoordinates
    },
    getPlannerSelectedTransports(state) {
      return state.plannerSelectedTransports
    },
    getPlannerSelectedOperators(state) {
      return state.plannerSelectedOperators
    },
    getPlannerTimeMode(state) {
      return state.plannerTimeMode
    },
    getPlannerTimeModeHour(state) {
      return state.plannerTimeModeHour
    },
    getPlannerTimeModeDate(state) {
      return state.plannerTimeModeDate
    },
    getPlannerSelectedTime(state){
      return state.plannerSelectedTime
    }
  }
})
